module.exports = __webpack_public_path__ + "img/1008.5c128851.png";